export default "__VITE_PUBLIC_ASSET__353d8fb6__"